import api from "./http";

const API_URL = `/api/email-monitored-jobs`;

/**
 * Récupère la liste des jobs de sauvegarde avec filtres optionnels
 */
export async function getMonitoredJobs({
    clientId,
    limit = 50,
    offset = 0,
} = {}) {
    try {
        const params = new URLSearchParams();
        if (limit) params.append("limit", limit);
        if (offset) params.append("offset", offset);
        if (clientId) params.append("clientId", clientId);

        const res = await api.get(`${API_URL}?${params.toString()}`, {
            timeout: 15000,
        });

        // Gérer différents formats de réponse
        if (res.data?.data) return res.data;
        if (res.data?.success && Array.isArray(res.data.data)) return res.data;
        if (Array.isArray(res.data)) {
            return { data: res.data, total: res.data.length, success: true };
        }

        return { data: [], total: 0, success: true };
    } catch (error) {
        console.error("Error fetching monitored jobs:", error);
        return { data: [], total: 0, success: false, error };
    }
}

/**
 * Récupère un job de sauvegarde par son ID
 */
export async function getMonitoredJob(id) {
    const res = await api.get(`${API_URL}/${id}`);
    return res.data?.data || res.data;
}

/**
 * Crée un nouveau job de sauvegarde
 */
export async function createMonitoredJob(data) {
    const res = await api.post(API_URL, data);
    return res.data?.data || res.data;
}

/**
 * Met à jour un job de sauvegarde
 */
export async function updateMonitoredJob(id, data) {
    const res = await api.put(`${API_URL}/${id}`, data);
    return res.data?.data || res.data;
}

/**
 * Supprime un job de sauvegarde
 */
export async function deleteMonitoredJob(id) {
    await api.delete(`${API_URL}/${id}`);
}

/**
 * Récupère la liste des clients pour les filtres
 */
export async function getClientsForFilter() {
    try {
        const res = await api.get("/api/clients", {
            headers: { Accept: "application/ld+json" },
            timeout: 15000,
        });
        const data = res.data;
        if (data && Array.isArray(data["hydra:member"]))
            return data["hydra:member"];
        if (data && Array.isArray(data["member"])) return data["member"];
        if (Array.isArray(data)) return data;
        return [];
    } catch (error) {
        console.error("Error fetching clients:", error);
        return [];
    }
}

/**
 * Déclenche la synchronisation et l'analyse des emails
 */
export async function syncAndAnalyzeEmails(options = {}) {
    try {
        const res = await api.post(
            "/api/email-sync-analyze",
            {
                daysBack: options.daysBack ?? 7,
                statusTypeName: options.statusTypeName || "COMPLETED",
                emailLimit: options.emailLimit || 100,
                unreadOnly: options.unreadOnly || false,
                jobIds: options.jobIds || null,
            },
            {
                timeout: 45000,
            },
        );
        return res.data;
    } catch (error) {
        console.error("Error syncing and analyzing emails:", error);
        throw error;
    }
}
